import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import {isChannelEnabled} from '../../../utils/channels';
import CawiInfo from '../channels/CawiInfo';

const ShareChannels = ({survey}) => (
    <div className="row">
        <div className="col">
            <h2><FormattedMessage {...messages.channels.cawi} /></h2>
            {isChannelEnabled(survey, constants.CHANNEL_TYPES.CAWI) && <CawiInfo surveyId={survey.id} />}
        </div>
    </div>
);

export default ShareChannels;
